import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProxyContext } from '@app/core/enums/proxy-context.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { HttpRequestService } from '@app/core/services/http-request.service';
import { Observable } from 'rxjs';
import { AddDestinatarioCommand } from '../command/addDestinatario.command';
import { AddRemitentCommand } from '../command/addRemitente.command';
import { DeleteDestinatario } from '../command/deleteDestinatario.command';
import { DeleteRemitente } from '../command/deleteRemitente.command';
import { FileSapCommand } from '../command/fileSap.command';
import { ConfirmGuideCommand } from '../command/generate-guide.command';
import { GenerateODCCommand } from '../command/generate-odc.command';
import { CatalogCFDICommand } from '../command/get-catalog-cfdi.command';
import { DataBillingCommand } from '../command/get-data-billing.command';
import { GetGuidesImpDetailCommand } from '../command/get-gudies-imp-detail.command';
import { GetRemitentesCommand } from '../command/get-remitentes.command';
import { PurchaseDetailCommand } from '../command/purchase-detail.command';
import { RemoveProdcutFromCartCommand } from '../command/remove-product-cart.command';
import { UpdateDataBillingCartCommand } from '../command/update-data-billing.command';
import { UpdateDestinatarioCommand } from '../command/update-destinatario.command';
import { UpdateProductCommand } from '../command/update-product-cart.command';
import { UpdateRemitentCommand } from '../command/update-remitente.command';
import { ZipCodeCommand } from '../command/zip-code.command';

@Injectable({
  providedIn: 'root'
})
export class ClientsServiceService {
  constructor(public requestService: HttpRequestService) {}

  /**
   *
   * Get all articles to cart
   */
  getProductsToMyCart(command: PurchaseDetailCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetAllCart, command);
  }

  /**
   *
   * Cancel to cart
   */
  cancelProductsFromCart(): Observable<HttpServerResponse<any>> {
    return this.requestService.get<HttpServerResponse<any>>(ProxyContext.CancelCart);
  }

  /**
   *
   * Update to quantity of the product from cart
   */
  updateQuantityProductFromCart(command: UpdateProductCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.put<HttpServerResponse<any>>(ProxyContext.UpdateCart, command);
  }

  /**
   *
   * Remove the product from cart
   */
  removeProductFromCart(command: RemoveProdcutFromCartCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.RemoveProductFromCart, command);
  }

  /**
   *
   * Validate the email account retail
   */
  validateRetailAccount(command: PurchaseDetailCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.ValidateAccountRetail, command);
  }

  // LOGUED REQUIRED
  /**
   *
   * Get the billing data the client
   */
  getDataBilling(command: DataBillingCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetDataBillingCart, command);
  }
  // LOGUED REQUIRED
  /**
   *
   * update billing data cart the client
   */
  UpdateDataBilling(command: UpdateDataBillingCartCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.UpdateDataBillingCart, command);
  }

  /**
   *
   * Get the billing data the client
   */
  getCatalogsTypePay(): Observable<HttpServerResponse<any>> {
    return this.requestService.get<HttpServerResponse<any>>(ProxyContext.GetCatalogsTypePay);
  }

  /**
   *
   * Get the billing data the client
   */
  generateODC(command: GenerateODCCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GenerateODC, command, { timeout: 1200000 });
  }
  /**
   * Method para agregar remitentes
   *
   * @param command- -
   * @returns
   */
  addRemitente(command: AddRemitentCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.AddRemitentesPrint, command);
  }

  /**
   * Method para actualizar remitentes
   *
   * @param command- -
   * @returns
   */
  updateRemitente(command: UpdateRemitentCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.UpdateRemitente, command);
  }

  /**
   * Method para actualizar destinatarios
   *
   * @param command- -
   * @returns
   */
  updateDestinatario(command: UpdateDestinatarioCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.UpdateDestinatario, command);
  }

  /**
   * Method para agregar Destinatario
   *
   * @param command- -
   * @returns
   */
  addDestinatario(command: AddDestinatarioCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.AddDestinatario, command);
  }
  /**
   * Method para mostrar remitentes
   *
   * @param command
   * @returns
   */
  getRemitente(command: GetRemitentesCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetRemitentes, command);
  }
  /**
   * Method para mostrar Destinatarios
   *
   * @param command
   * @returns
   */
  getDestinatario(command: GetRemitentesCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetDestinatario, command);
  }

  /**
   * Method para traer todas las ciudades
   *
   * @param command
   * @returns
   */
  getAllCity(command: ZipCodeCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.ZipeCode, command);
  }

  /**
   * Method para traer los detalles para la impresión
   *
   * @param command
   * @returns
   */
  getDetailsPrint(command: GetGuidesImpDetailCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GetDetailPrint, command);
  }
  /**
   * Method para confirmar guía
   *
   * @param command
   * @returns
   */
  confirmGuide(command: ConfirmGuideCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.ConfirmPrint, command);
  }
  /**
   * Metodo para Eliminar Remitentes
   *
   * @returns
   */
  deleteRemitente(command: DeleteRemitente): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.DeleteRemitente, command);
  }
  /**
   * Metodo para Eliminar Destinatario
   *
   * @returns
   */
  deleteDestinatario(command: DeleteDestinatario): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.DeleteDestinatario, command);
  }
  /**
   * Method para generar y descargar un reporte
   *
   * @param command- -
   * @returns
   */
  downlandReport(command: FileSapCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.GenerateDownloadReport, command);
  }
  /**
   * Method para generar y descargar un reporte
   *
   * @param command- -
   * @returns
   */
  getCatalogCFDI(command: CatalogCFDICommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.catalogCFDI, command);
  }
}
